<template>
	<div>
		<div class="botton">
			@店开知识共享平台 BY 2023 &nbsp;&nbsp; 浙ICP备20016250号-1
		</div>
	</div>
</template>

<script>
	export default {
		components:{},
		data() {
			return {
				
			}
		},
		created() {
			
		},
		methods:{
			
		}
	}
</script>

<style scoped lang="less">
	.botton{
		background-color: #000;
		line-height: 5vh;
		color: #fff;
		text-align: center;
		font-size: 13px;
		z-index: 200;
	}
</style>